import { useQuery } from '@tanstack/react-query'
import { useAuth } from '../auth/AuthContext'
import { apiFetch } from '../api/client'
import type { GlowUsage } from '../api/types'

// useGlowUsage fetches the Usage tab's single data source — live grouped
// storage plus monthly bandwidth counters/caps — from
// GET /v1/glows/{id}/usage. Modeled on useDataKeys: gated on an
// authenticated user and a non-empty glow id.
export function useGlowUsage(glowID: string) {
  const { idTokenProvider, user } = useAuth()
  return useQuery({
    queryKey: ['glow-usage', glowID],
    queryFn: ({ signal }) =>
      apiFetch<GlowUsage>(`/v1/glows/${glowID}/usage`, idTokenProvider, { signal }),
    enabled: !!user && !!glowID,
  })
}
